"use client";

import React from "react";
import { usePathname } from "next/navigation";
import { NavList } from "./nav-list";

export function Nav() {
  const pathname = usePathname();

  return (
    <>
      {/* Mobile Nav */}
      <div className="fixed right-4 bottom-4 left-4 z-50 flex h-14 w-max items-center justify-center rounded-full lg:hidden">
        {/* Blurred background */}
        <div className="absolute inset-0 h-full w-full rounded-full shadow-[inset_1px_1px_0_rgba(255,255,255,1),inset_-1px_-1px_0_rgba(255,255,255,0.5)] drop-shadow-xl backdrop-blur-xs backdrop-saturate-300 dark:shadow-[inset_1px_1px_0_rgba(255,255,255,0.25),inset_-1px_-1px_0_rgba(255,255,255,0.15)]" />
        {/* Nav content with blend mode */}
        <nav className="relative z-10 h-full w-full overflow-x-auto">
          <div className="flex h-full w-full items-center justify-center">
            <div className="m-auto flex w-full list-none items-center justify-center space-x-2">
              <NavList isMobile pathname={pathname!} />
            </div>
          </div>
        </nav>
      </div>

      {/* Desktop Nav */}
      <div className="fixed top-4 z-50 flex w-full justify-center">
        <div className="relative flex max-w-max items-center justify-center rounded-full py-1">
          {/* Blurred background */}
          <div className="absolute inset-0 h-full w-full rounded-full shadow-[inset_1px_1px_0_rgba(255,255,255,1),inset_-1px_-1px_0_rgba(255,255,255,0.5)] drop-shadow-2xl backdrop-blur-xs backdrop-saturate-300 dark:shadow-[inset_1px_1px_0_rgba(255,255,255,0.25),inset_-1px_-1px_0_rgba(255,255,255,0.15)]" />
          {/* Nav content */}
          <nav className="relative z-10">
            <NavList pathname={pathname!} />
          </nav>
        </div>
      </div>
    </>
  );
}
